module.exports = __webpack_public_path__ + "img/bcfbc03.jpg";